import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import usePrevious from '../../hooks/use-previous';

// components
import IconExpand from '../icons/expand';
import IconCollapse from '../icons/collapse';
import { SidebarItemTypes } from './types';

// styles
import styles from './sidebar-item.module.css';

export default function SidebarItem({
  children,
  links,
  className,
  hidden = false,
  onClick,
  location,
  locations,
  pathname,
  onMouseDown,
}: SidebarItemTypes): React.JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  const prevOpen = usePrevious(isOpen);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  let content = <div />;

  useEffect(() => {
    if (
      location &&
      pathname &&
      !isOpen &&
      prevOpen === null &&
      pathname !== '/'
    ) {
      const pathnameArray = pathname.slice(1).split('/');

      if (location.includes(pathnameArray[0])) {
        setIsOpen(true);
      }
    }
  }, [location, pathname, isOpen, prevOpen]);

  useEffect(() => {
    if (
      pathname &&
      pathname !== '/' &&
      locations &&
      locations.length > 0 &&
      !isOpen &&
      prevOpen === null
    ) {
      const pathnameArray = pathname.slice(1).split('/');

      if (
        locations.find((item) => {
          const itemArray = item.slice(1).split('/');

          return itemArray[0] === pathnameArray[0];
        })
      ) {
        setIsOpen(true);
      }
    }
  }, [isOpen, locations, pathname, prevOpen]);

  if (!hidden) {
    content = (
      <div
        className={`${styles.sidebarItem} ${className || ''} ${
          isOpen ? styles.isOpen : ''
        }`}
      >
        <button
          type="button"
          className={styles.sidebarItemHead}
          onClick={toggleOpen}
        >
          <span className={styles.sidebarItemLabel}>{children}</span>
          {isOpen ? (
            <IconCollapse className={styles.sidebarItemIcon} />
          ) : (
            <IconExpand className={styles.sidebarItemIcon} />
          )}
        </button>
        {isOpen && (
          <div className={`${styles.sidebarItemLinks} slide-in-right`}>
            {links
              .filter((item) => !item.hidden)
              .map((link) => (
                <NavLink
                  key={link.label}
                  to={link.to}
                  className={({ isActive }) =>
                    `${link.className as string} ${
                      isActive ? styles.activeLink : ''
                    }`
                  }
                  caseSensitive={link.caseSensitive}
                  end={link.end}
                  style={link.style}
                  onClick={() => onClick && onClick()}
                  onMouseDown={(e) => onMouseDown && onMouseDown(e)}
                >
                  {link.label}
                </NavLink>
              ))}
          </div>
        )}
      </div>
    );
  }

  return content;
}
